import React from "react";

const sizeMap = {
  sm: "text-sm px-4 h-9",
  md: "text-sm md:text-[15px] px-6 h-11",
  lg: "text-[15px] md:text-base px-7 h-12",
};

// Variants — primary is BLUE (per brand pairing); orange is reserved for
// secondary accents and the "warm" outline variant.
const variantMap = {
  primary:
    "bg-brand-blue text-white hover:bg-brand-blue-dark shadow-sm hover:shadow-md transition-[background-color,box-shadow,transform] hover:-translate-y-[1px]",
  outline:
    "bg-transparent border border-ink/20 text-ink hover:border-ink hover:text-ink transition-colors",
  "outline-orange":
    "bg-transparent border border-brand-orange text-brand-orange hover:bg-brand-orange hover:text-white transition-colors",
  "outline-blue":
    "bg-transparent border border-brand-blue text-brand-blue hover:bg-brand-blue hover:text-white transition-colors",
  warm:
    "bg-brand-orange text-white hover:bg-brand-orange-dark shadow-sm hover:shadow-md transition-[background-color,box-shadow,transform] hover:-translate-y-[1px]",
  ghost:
    "bg-transparent text-ink hover:text-brand-blue transition-colors px-3",
  light:
    "bg-white text-ink border border-border hover:border-ink/40 transition-colors",
};

export const QButton = React.forwardRef(
  (
    {
      children,
      variant = "primary",
      size = "md",
      as = "button",
      className = "",
      icon: Icon,
      iconRight: IconRight,
      ...rest
    },
    ref
  ) => {
    const Tag = as;
    return (
      <Tag
        ref={ref}
        className={`inline-flex items-center justify-center gap-2 rounded-full font-medium tracking-tight whitespace-nowrap focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-blue/40 focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none ${sizeMap[size]} ${variantMap[variant]} ${className}`}
        {...rest}
      >
        {Icon && <Icon className="h-4 w-4" strokeWidth={1.75} />}
        <span>{children}</span>
        {IconRight && <IconRight className="h-4 w-4" strokeWidth={1.75} />}
      </Tag>
    );
  }
);
QButton.displayName = "QButton";

export default QButton;
